import React from 'react';

interface HelpIconProps {
  size?: number;
  color?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({
  size = 17,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4165 8.05032C14.4165 4.53455 11.5661 1.68429 8.05032 1.68411C4.53444 1.68411 1.68411 4.53444 1.68411 8.05032C1.68429 11.5661 4.53455 14.4165 8.05032 14.4165C11.566 14.4164 14.4164 11.566 14.4165 8.05032ZM15.5659 8.05032C15.5658 12.2011 12.2011 15.5658 8.05032 15.5659C3.89943 15.5659 0.533903 12.2012 0.533722 8.05032C0.533722 3.89931 3.89931 0.533722 8.05032 0.533722C12.2012 0.533903 15.5659 3.89943 15.5659 8.05032Z"
      fill={color}
    />
    <path
      d="M5.60604 6.18124C5.60604 5.69782 5.74941 5.22471 6.01815 4.82284C6.28686 4.42105 6.66918 4.10834 7.11581 3.92343C7.56259 3.73853 8.05464 3.68953 8.52889 3.78378C9.00311 3.87805 9.43885 4.11103 9.78085 4.45272C10.1228 4.79436 10.3554 5.22975 10.4498 5.7037C10.5442 6.17769 10.5442 6.6693 10.3111 7.11581C10.126 7.56241 9.8119 7.94403 9.40975 8.21249C9.16966 8.37276 8.90426 8.48711 8.62655 8.55429V9.2955C8.6265 9.61302 8.36889 9.87069 8.05136 9.87069C7.73397 9.87051 7.47718 9.61291 7.47714 9.2955V8.0494C7.47723 7.73203 7.734 7.47439 8.05136 7.47421C8.30768 7.47421 8.55902 7.39866 8.77206 7.25643C8.98496 7.11422 9.15069 6.9116 9.24862 6.67538C9.34649 6.43914 9.37178 6.17907 9.32186 5.92831C9.27189 5.67767 9.14928 5.44706 8.96835 5.2662C8.7872 5.08522 8.55568 4.96166 8.30429 4.91171C8.05308 4.86184 7.79284 4.88808 7.55624 4.98593C7.31945 5.08392 7.11648 5.24976 6.97421 5.46249C6.83203 5.67518 6.75643 5.92558 6.75643 6.18124C6.75622 6.49862 6.49867 6.75546 6.18124 6.75546C5.86381 6.75546 5.60626 6.49862 5.60604 6.18124Z"
      fill={color}
    />
    <path
      d="M8.16583 10.6458C8.42788 10.6994 8.62482 10.9314 8.62482 11.2093C8.62482 11.3062 8.59781 11.3958 8.55548 11.4759C8.598 11.5561 8.62482 11.6463 8.62482 11.7434C8.62468 12.0609 8.3671 12.3186 8.04962 12.3186C7.61405 12.3185 7.25604 11.987 7.21271 11.5628L7.20782 11.4759L7.21271 11.3899C7.25593 10.9655 7.61397 10.6342 8.04962 10.6341L8.16583 10.6458ZM8.11407 11.1751C8.09339 11.1707 8.07161 11.1682 8.04962 11.1682C8.07141 11.1682 8.09291 11.1727 8.11407 11.1751Z"
      fill={color}
    />
    <path
      d="M8.04962 10.6341C8.51446 10.6341 8.89159 11.0109 8.89178 11.4759C8.89178 11.9409 8.51458 12.3186 8.04962 12.3186C7.73214 12.3186 7.47493 12.0609 7.47479 11.7434C7.47479 11.6464 7.50166 11.5561 7.54413 11.4759C7.50185 11.3958 7.47479 11.3061 7.47479 11.2093C7.47479 10.8917 7.73206 10.6341 8.04962 10.6341Z"
      fill={color}
    />
  </svg>
);

export default HelpIcon;
